import Api from "./Api";
import Utils from "../utilities/Utils";
import { NewsTag } from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class NewsTagsController extends Api {
  static getNewsTags(newsCenterId: string, params: object) {
    return fetch(
      `/api/news_centers/${newsCenterId}/news_tags?${SearchHelper.getQueryString(
        params
      )}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }

  static get(newsCenterId: string, params: any) {
    return fetch(
      `/api/news_centers/${newsCenterId}/news_tags/${
        params.id
      }?${Utils.encodeQueryData(params)}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }

  static create(newsCenterId: string, newsTag: NewsTag) {
    return fetch(`/api/news_centers/${newsCenterId}/news_tags`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({
        news_tag: newsTag,
      }),
    }).then((res) => res.json());
  }

  static update(newsCenterId: string, newsTag: NewsTag) {
    return fetch(`/api/news_centers/${newsCenterId}/news_tags/${newsTag.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ news_tag: newsTag }),
    }).then((res) => res.json());
  }

  static delete(newsCenterId: string, id: string) {
    return fetch(`/api/news_centers/${newsCenterId}/news_tags/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getForm(newsCenterId: string, id?: string) {
    const params = { id: id };

    return fetch(
      `/api/news_centers/${newsCenterId}/news_tags/form?${Utils.encodeQueryData(
        params
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }
}
